module.exports = __webpack_public_path__ + "static/img/Seguros.95b75de8.png";